import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
var Header$1 = styled.header(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  min-height: 108px;\n  max-height: 108px;\n  padding: 0 32px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid ", ";\n  font-weight: bold;\n  font-size: 28px;\n  line-height: 36px;\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
}, function (p) {
  return p.theme.palette.gray['200'];
});

function Header(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(Header$1, null, children));
}

export { Header };
